export function forceString(value: string | string[] | undefined) {
  if (value === undefined) {
    return '';
  }

  return typeof value === 'string' ? value : value.toString();
}
